import moment from "moment";

export const formatTimestamp = (timestamp: Date | string): string => {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const amPm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format

  return `${formattedHours}:${minutes} ${amPm}`;
};

// get current data | format : 2025-01-21
export const getCurrentDate = () => moment().format("YYYY-MM-DD");
